import { Button } from '../atoms/Button/Button';
import { useTranslation } from '../../i18n/useTranslation';
import { useOnboardingOptional } from './OnboardingContext';

function TourIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
      <circle cx="10" cy="10" r="7.5" stroke="currentColor" strokeWidth="1.5" />
      <path
        d="M7.75 7.75a2.25 2.25 0 1 1 3.1 2.08c-.5.21-.85.69-.85 1.23v.44"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <circle cx="10" cy="14" r="0.9" fill="currentColor" />
    </svg>
  );
}

export interface OnboardingHelpButtonProps {
  className?: string;
  iconClassName?: string;
  labelClassName?: string;
  /** Collapsed sidebar: icon only (the accessible name stays). */
  iconOnly?: boolean;
}

/** "Take the tour" entry in the sidebar footer — opens the onboarding tour by hand. */
export function OnboardingHelpButton({ className, iconClassName, labelClassName, iconOnly = false }: OnboardingHelpButtonProps) {
  const { t } = useTranslation();
  const onboarding = useOnboardingOptional();
  if (onboarding === null) return null;
  return (
    <Button
      variant="ghost"
      fullWidth
      className={className}
      onClick={onboarding.open}
      aria-label={iconOnly ? t('onboarding.helpEntry') : undefined}
      data-testid="onboarding-help-button"
    >
      <span className={iconClassName}><TourIcon /></span>
      {!iconOnly && <span className={labelClassName}>{t('onboarding.helpEntry')}</span>}
    </Button>
  );
}

export default OnboardingHelpButton;
